// Tote Bag de regalo — Ochi & Co · Cyber 2026 · OPT-IN por checkbox (no fuerza, no rebota, removible).
// < $60.000: barra "te faltan $X" + checkbox opcional para agregarla por $3.990 (la clienta decide).
// >= $60.000: checkbox para sumarla GRATIS (descuento BXGY "Cyber · Tote gratis sobre $60.000" la deja en $0).
// Variante con stock real (53059863609660). Reemplaza al auto-add roto del 2026-05-29.
(function() {
  if (window.__ochiCyberToteLoaded) return;
  window.__ochiCyberToteLoaded = true;

  var TOTE_VARIANT = 53059863609660;   // variante con stock (797), $3.990
  var THRESHOLD = 6000000;             // $60.000 en cents
  var CYBER_START = Date.UTC(2026, 4, 29, 13, 0, 0);  // 2026-05-29 09:00 -04
  var CYBER_END   = Date.UTC(2026, 5, 4, 3, 59, 59);  // 2026-06-03 23:59 -04
  var preview = location.search.indexOf('cyber=preview') !== -1;
  function active() { var n = Date.now(); return preview || (n >= CYBER_START && n <= CYBER_END); }
  if (!active()) return;

  var busy = false;

  function getCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function(r){ return r.json(); }); }
  function subEx(cart) { return cart.items.reduce(function(s,i){ return i.variant_id === TOTE_VARIANT ? s : s + (i.line_price || i.price * i.quantity); }, 0); }
  function toteIn(cart) { return cart.items.find(function(i){ return i.variant_id === TOTE_VARIANT; }); }
  function fmt(c) { return '$' + Math.round(c/100).toLocaleString('es-CL'); }

  function notifyCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
  }

  function addTote() {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: TOTE_VARIANT, quantity: 1, properties: { 'Regalo Cyber': 'Tote Bag' } }] })
    });
  }
  function removeTote(key) {
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  function onToggle(e) {
    var cb = e.target;
    if (busy) { return; }
    busy = true; cb.disabled = true;
    getCart().then(function(cart) {
      var t = toteIn(cart);
      if (cb.checked && !t) return addTote();
      if (!cb.checked && t) return removeTote(t.key);
    }).then(function(){ notifyCart(); }).catch(function(){})
      .finally(function(){ busy = false; setTimeout(render, 450); });
  }

  function injectStyles() {
    if (document.getElementById('ochi-ct-style')) return;
    var st = document.createElement('style');
    st.id = 'ochi-ct-style';
    st.appendChild(document.createTextNode(
      '#ochi-cyber-tote{margin:0 0 12px;padding:12px 14px;background:#f7f5f2;border:1px solid #e5e2dd;border-radius:4px;' +
      'font-family:Montserrat,sans-serif;font-size:13px;color:#3C322A;line-height:1.45;display:flex;align-items:flex-start;gap:12px}' +
      '#ochi-cyber-tote.ct-on{background:#f3efe9;border-color:#d8cfc2}' +
      '#ochi-cyber-tote img{width:34px;height:54px;object-fit:contain;flex-shrink:0}' +
      '#ochi-cyber-tote .ct-txt{flex:1}#ochi-cyber-tote strong{font-weight:600}' +
      '#ochi-cyber-tote .ct-bar{background:#e7e1d8;border-radius:3px;height:4px;margin:7px 0 9px;overflow:hidden}' +
      '#ochi-cyber-tote .ct-bar>span{display:block;height:100%;background:#3C322A;border-radius:3px;transition:width .3s}' +
      '#ochi-cyber-tote label.ct-opt{display:flex;align-items:center;gap:10px;cursor:pointer;margin:4px 0 0;min-height:44px;padding:4px 0;-webkit-tap-highlight-color:transparent}' +
      '#ochi-cyber-tote .ct-checkbox{min-width:22px;min-height:22px;width:22px;height:22px;accent-color:#3C322A;cursor:pointer;margin:0;flex-shrink:0}' +
      '#ochi-cyber-tote .ct-free{color:#3f7733;font-weight:600}'
    ));
    document.head.appendChild(st);
  }

  var IMG = 'https://cdn.shopify.com/s/files/1/0793/5315/1804/t/3/assets/tote-bag-nobg.png?v=1773338517';

  // Devuelve el HTML interno segun estado
  function buildInner(free, inCart, subtotal) {
    var img = '<img src="' + IMG + '" alt="Tote Bag Ochi & Co" loading="lazy">';
    var checked = inCart ? ' checked' : '';
    var body = '';
    if (free) {
      // >= $60.000 -> gratis
      body += inCart
        ? '<strong class="ct-free">Tu Tote Bag va de regalo</strong><br>Incluida en esta compra.'
        : '<strong>Ya superaste los $60.000</strong><br>Tu Tote Bag va de regalo.';
      body += '<label class="ct-opt"><input type="checkbox" class="ct-checkbox"' + checked + '>' +
              '<span>' + (inCart ? 'Quitar mi Tote Bag' : 'Sumar mi Tote Bag <strong class="ct-free">gratis</strong>') + '</span></label>';
    } else {
      // < $60.000 -> opcional pagada + barra de progreso
      var faltan = THRESHOLD - subtotal;
      var pct = Math.min(100, Math.round((subtotal / THRESHOLD) * 100));
      body += 'Te faltan <strong>' + fmt(faltan) + '</strong> para tu Tote Bag de regalo';
      body += '<div class="ct-bar"><span style="width:' + pct + '%"></span></div>';
      body += '<label class="ct-opt"><input type="checkbox" class="ct-checkbox"' + checked + '>' +
              '<span>' + (inCart ? 'Tote Bag agregada por <strong>$3.990</strong> (quitar)' : 'O agr&eacute;gala ahora por <strong>$3.990</strong>') + '</span></label>';
    }
    return img + '<div class="ct-txt">' + body + '</div>';
  }

  function anchorAndPlace(node) {
    var footer = document.querySelector('.cart-drawer__footer');
    if (footer) {
      var sub = footer.querySelector('.subtotal');
      if (sub && sub.parentNode) { sub.parentNode.insertBefore(node, sub); return true; }
      footer.insertBefore(node, footer.firstChild); return true;
    }
    var sub2 = document.querySelector('.cart__footer .subtotal, .subtotal');
    if (sub2 && sub2.parentNode) { sub2.parentNode.insertBefore(node, sub2); return true; }
    return false;
  }

  var rendering = false;
  function render() {
    if (rendering) return; rendering = true;
    getCart().then(function(cart) {
      var old = document.getElementById('ochi-cyber-tote');
      if (!cart || !cart.items || cart.items.length === 0) { if (old) old.remove(); return; }
      var sub = subEx(cart);
      var inCart = !!toteIn(cart);
      var free = sub >= THRESHOLD;

      injectStyles();
      var node = old || document.createElement('div');
      node.id = 'ochi-cyber-tote';
      node.className = (free ? 'ct-on' : '');
      node.innerHTML = buildInner(free, inCart, sub);
      if (!old) { if (!anchorAndPlace(node)) { rendering = false; return; } }
      var cb = node.querySelector('.ct-checkbox');
      if (cb) cb.addEventListener('change', onToggle);
    }).catch(function(){}).finally(function(){ rendering = false; });
  }

  function init() { render(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  var origFetch = window.fetch;
  window.fetch = function(input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url);
    var p = origFetch.apply(this, arguments);
    if (url && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1)) {
      return p.then(function(resp){ setTimeout(render, 350); return resp; });
    }
    return p;
  };
  document.addEventListener('cart:updated', function(){ setTimeout(render, 350); });
  document.addEventListener('cart:refresh', function(){ setTimeout(render, 350); });
})();
